





































































































































































































































































































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import MultiSelectModal from '@/components/modal/MultiSelectModal.vue'
import AreaModal from '@/components/modal/AreaModal/AreaModal.vue'
import TimeModal, {
  TimeRange,
} from '@/components/modal/DatetimeModal/TimeModal.vue'
import { ProgramLevel, programLevelOptions, Area } from '@/core/Programs'
import {
  ActivityId,
  activitiesToOptions,
  ActivityOption,
} from '@/core/Activities'
import { AreaId } from '@/core/Facilities'
import {
  DayOfWeek,
  dayOfWeekOptions,
  TimeSlot,
  getMyKarte,
  updateKarte,
  defaultTimeSlots,
} from '@/core/Kartes'
import { User } from '@/core/Auth'
import snackbar from '@/tools/snackbar'
import Button from '@/components/globals/Button.vue'
import Placeholder from './Placeholder.vue'
import GridButtons from './GridButtons.vue'
import KarteIntroModal from './KarteIntroModal.vue'
import FindFacilitiesFromKarteModal from './FindFacilitiesFromKarteModal.vue'
import { pushRegisterKarteEvent, pushEditKarteEvent } from '@/tools/gtm'

// 平日
const weekdays = [
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
]

// 祝日
const holidays = [DayOfWeek.SATURDAY, DayOfWeek.SUNDAY]

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    Button,
    Placeholder,
    GridButtons,
    MultiSelectModal,
    // TODO: エリア選択モーダルはひとまずプログラム検索から借りているが、汎用的なモーダルに変更したい
    AreaModal,
    // TODO: 時間選択モーダルはひとまずプログラム検索から借りているが、汎用的なモーダルに変更したい
    TimeModal,
    KarteIntroModal,
    FindFacilitiesFromKarteModal,
  },
  filters: {
    toWeekdayCheckboxIconName(
      dayOfWeeks: DayOfWeek[]
    ): 'checkbox_null' | 'checkbox' | 'checkbox_intermediate' {
      const intersection = weekdays.filter((d) => dayOfWeeks.includes(d))
      return !intersection.length
        ? 'checkbox_null'
        : intersection.length === weekdays.length
        ? 'checkbox'
        : 'checkbox_intermediate'
    },
    toHolidayCheckboxIconName(
      dayOfWeeks: DayOfWeek[]
    ): 'checkbox_null' | 'checkbox' | 'checkbox_intermediate' {
      const intersection = holidays.filter((d) => dayOfWeeks.includes(d))
      return !intersection.length
        ? 'checkbox_null'
        : intersection.length === holidays.length
        ? 'checkbox'
        : 'checkbox_intermediate'
    },
    toDayOfWeeksLabel(dayOfWeeks: DayOfWeek[]) {
      return dayOfWeeks.length === 0
        ? '曜日を入力'
        : dayOfWeeks
            .map(
              (dayOfWeek) =>
                dayOfWeekOptions.find(({ value }) => value === dayOfWeek)
                  ?.label || ''
            )
            .join(', ')
    },
    toTimeRange(timeSlot: TimeSlot): TimeRange {
      const [fromHour, fromMinute] = timeSlot.startTimeFrom.split(':')
      const [toHour, toMinute] = timeSlot.startTimeTo.split(':')
      return {
        from: {
          hour: fromHour,
          minute: fromMinute,
        },
        to: {
          hour: toHour,
          minute: toMinute,
        },
      }
    },
  },
  data() {
    return {
      isFetching: false,
      timeSlots: [] as TimeSlot[],
      areas: [] as Area[],
      areaIds: [] as AreaId[],
      levels: [] as ProgramLevel[],
      activityOptions: [] as ActivityOption[],
      activityIds: [] as ActivityId[],
      isSubmitting: false,
      isRegistered: false,
    }
  },
  computed: {
    user(): User {
      return this.$store.getters['auth/user']
    },
    programLevelOptions() {
      return programLevelOptions
    },
    dayOfWeekOptions() {
      return dayOfWeekOptions
    },
    validTimeSlots(): TimeSlot[] {
      return this.timeSlots.filter(
        (timeSlot) => !this.isTimeSlotInvalid(timeSlot)
      )
    },
    isValid(): boolean {
      return (
        this.validTimeSlots.length !== 0 &&
        this.areaIds.length !== 0 &&
        this.levels.length !== 0 &&
        this.activityIds.length !== 0
      )
    },
  },
  methods: {
    getAreaName(areaId: AreaId) {
      return this.areas.find(({ id }) => id === areaId)?.name || ''
    },
    async handleBeforeOpen() {
      this.isFetching = true
      try {
        const { data, meta } = await getMyKarte()
        const { timeSlots, exerciseLevels, areas, activities, registered } =
          data

        // タイムスロットが未登録の場合、1件以上の入力が必須のため初回の登録となる
        // 初回の登録の場合はデフォルトのタイムスロットをプリセットとしてセットする
        this.timeSlots =
          timeSlots.length === 0 ? [...defaultTimeSlots] : timeSlots

        this.levels = exerciseLevels
        this.areaIds = areas
        this.activityIds = activities

        this.activityOptions = activitiesToOptions(meta.activities)
        this.areas = meta.areas

        this.isRegistered = registered

        // 初回登録時にカルテの紹介モーダルを表示する
        if (!registered) {
          this.$modal.push('KarteIntroModal', true)
        }
      } catch (e) {
        snackbar({ text: 'カルテを取得できませんでした。' })
      } finally {
        this.isFetching = false
      }
    },
    isTimeSlotInvalid(timeSlot: TimeSlot) {
      return (
        timeSlot.dayOfWeeks.length === 0 ||
        !timeSlot.startTimeFrom ||
        !timeSlot.startTimeTo
      )
    },
    handleSelectArea() {
      this.$modal.push('PreferencesAreaModal', true)
    },
    handleAddTimeSlot() {
      this.timeSlots = [
        ...this.timeSlots,
        {
          dayOfWeeks: [],
          startTimeFrom: '',
          startTimeTo: '',
        },
      ]
    },
    handleClickDayOfWeek(index: number) {
      this.$modal.push(`${index}/WeekdayModal`, true)
    },
    handleClickTime(index: number) {
      this.$modal.push(`${index}/TimeModal`, true)
    },
    handleRemoveTimeSlot(index: number) {
      this.timeSlots = this.timeSlots.filter((_, i) => i !== index)
    },
    handleAreaChange(areaIds: AreaId[]) {
      this.areaIds = areaIds
    },
    getWeekdayIntersection(dayOfWeeks: DayOfWeek[]): DayOfWeek[] {
      return weekdays.filter((d) => dayOfWeeks.includes(d))
    },
    toggleWeekdays(dayOfWeeks: DayOfWeek[]): DayOfWeek[] {
      // 平日が指定されていない、または一つでも選択されていれば平日を全チェック
      return this.getWeekdayIntersection(dayOfWeeks).length < weekdays.length
        ? [...dayOfWeeks, ...weekdays].filter(
            (d, i, self) => self.indexOf(d) === i
          )
        : dayOfWeeks.filter((d) => !weekdays.includes(d))
    },
    getHolidayIntersection(dayOfWeeks: DayOfWeek[]): DayOfWeek[] {
      return holidays.filter((d) => dayOfWeeks.includes(d))
    },
    toggleHolidays(dayOfWeeks: DayOfWeek[]): DayOfWeek[] {
      // 休日が指定されていない、または一つでも選択されていれば休日を全チェック
      return this.getHolidayIntersection(dayOfWeeks).length < holidays.length
        ? [...dayOfWeeks, ...holidays].filter(
            (d, i, self) => self.indexOf(d) === i
          )
        : dayOfWeeks.filter((d) => !holidays.includes(d))
    },
    handleTimeSlotDayOfWeeksChange(index: number, dayOfWeeks: DayOfWeek[]) {
      this.timeSlots = this.timeSlots.map((timeSlot, i) =>
        i !== index
          ? timeSlot
          : {
              ...timeSlot,
              dayOfWeeks: dayOfWeeks.sort((a, b) => {
                // 日曜日は必ず最後にする。それ以外は月〜土の順番で並べる
                return a === DayOfWeek.SUNDAY
                  ? 1
                  : b === DayOfWeek.SUNDAY
                  ? -1
                  : a - b
              }),
            }
      )
    },
    handleTimeSlotTimeChange(index: number, timeRange: TimeRange) {
      this.timeSlots = this.timeSlots.map((timeSlot, i) =>
        i !== index
          ? timeSlot
          : {
              ...timeSlot,
              startTimeFrom:
                timeRange.from.hour && timeRange.from.minute
                  ? `${timeRange.from.hour}:${timeRange.from.minute}`
                  : '',
              startTimeTo:
                timeRange.to.hour && timeRange.to.minute
                  ? `${timeRange.to.hour}:${timeRange.to.minute}`
                  : '',
            }
      )
    },
    handleLevelChange(levels: ProgramLevel[]) {
      this.levels = levels
    },
    handleActivityChange(activityIds: ActivityId[]) {
      this.activityIds = activityIds
    },
    async onSubmit() {
      if (!this.isValid) return

      this.isSubmitting = true
      try {
        await updateKarte({
          timeSlots: this.validTimeSlots.map(
            ({ dayOfWeeks, startTimeFrom, startTimeTo }) => ({
              dayOfWeeks: [...dayOfWeeks],
              startTimeFrom,
              startTimeTo,
            })
          ),
          exerciseLevels: [...this.levels],
          areas: [...this.areaIds],
          activities: [...this.activityIds],
        })
        this.$modal.pop()

        // イベント発火
        !this.isRegistered
          ? pushRegisterKarteEvent(this.user.id)
          : pushEditKarteEvent(this.user.id)

        snackbar({
          text: this.isRegistered
            ? 'カルテを編集しました'
            : 'カルテを登録しました',
        })

        // 初回登録時は施設検索への遷移を促すモーダルを表示する
        if (!this.isRegistered) {
          this.$modal.push('FindFacilitiesFromKarteModal')
        }

        // 登録済みにする
        this.isRegistered = true
        this.isSubmitting = false
      } catch (e) {
        snackbar({
          text: this.isRegistered
            ? 'カルテの編集に失敗しました'
            : 'カルテの登録に失敗しました',
        })
        this.isSubmitting = false
      }
    },
    onClose() {
      this.$modal.pop()
      this.$emit('onClose')
    },
  },
})
